"use strict";
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
(function (global, factory) {
    /* AMD */ if (typeof define === 'function' && define.amd)
        define(["protobufjs/minimal"], factory);
    /* CommonJS */ else if (typeof require === 'function' && typeof module === 'object' && module && module.exports)
        module.exports = factory(require("protobufjs/minimal"));
})(this, function ($protobuf) {
    "use strict";
    // Common aliases
    var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
    // Exported root namespace
    var $root = $protobuf.roots["libp2p-noise"] || ($protobuf.roots["libp2p-noise"] = {});
    $root.pb = (function () {
        /**
         * Namespace pb.
         * @exports pb
         * @namespace
         */
        var pb = {};
        pb.NoiseHandshakePayload = (function () {
            /**
             * Properties of a NoiseHandshakePayload.
             * @memberof pb
             * @interface INoiseHandshakePayload
             * @property {Uint8Array|null} [identityKey] NoiseHandshakePayload identityKey
             * @property {Uint8Array|null} [identitySig] NoiseHandshakePayload identitySig
             * @property {Uint8Array|null} [data] NoiseHandshakePayload data
             */
            /**
             * Constructs a new NoiseHandshakePayload.
             * @memberof pb
             * @classdesc Represents a NoiseHandshakePayload.
             * @implements INoiseHandshakePayload
             * @constructor
             * @param {pb.INoiseHandshakePayload=} [properties] Properties to set
             */
            function NoiseHandshakePayload(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }
            /**
             * NoiseHandshakePayload identityKey.
             * @member {Uint8Array} identityKey
             * @memberof pb.NoiseHandshakePayload
             * @instance
             */
            NoiseHandshakePayload.prototype.identityKey = $util.newBuffer([]);
            /**
             * NoiseHandshakePayload identitySig.
             * @member {Uint8Array} identitySig
             * @memberof pb.NoiseHandshakePayload
             * @instance
             */
            NoiseHandshakePayload.prototype.identitySig = $util.newBuffer([]);
            /**
             * NoiseHandshakePayload data.
             * @member {Uint8Array} data
             * @memberof pb.NoiseHandshakePayload
             * @instance
             */
            NoiseHandshakePayload.prototype.data = $util.newBuffer([]);
            /**
             * Creates a new NoiseHandshakePayload instance using the specified properties.
             * @function create
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {pb.INoiseHandshakePayload=} [properties] Properties to set
             * @returns {pb.NoiseHandshakePayload} NoiseHandshakePayload instance
             */
            NoiseHandshakePayload.create = function create(properties) {
                return new NoiseHandshakePayload(properties);
            };
            /**
             * Encodes the specified NoiseHandshakePayload message. Does not implicitly {@link pb.NoiseHandshakePayload.verify|verify} messages.
             * @function encode
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {pb.INoiseHandshakePayload} message NoiseHandshakePayload message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            NoiseHandshakePayload.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.identityKey != null && Object.hasOwnProperty.call(message, "identityKey"))
                    writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.identityKey);
                if (message.identitySig != null && Object.hasOwnProperty.call(message, "identitySig"))
                    writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.identitySig);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 3, wireType 2 =*/ 26).bytes(message.data);
                return writer;
            };
            /**
             * Encodes the specified NoiseHandshakePayload message, length delimited. Does not implicitly {@link pb.NoiseHandshakePayload.verify|verify} messages.
             * @function encodeDelimited
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {pb.INoiseHandshakePayload} message NoiseHandshakePayload message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            NoiseHandshakePayload.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };
            /**
             * Decodes a NoiseHandshakePayload message from the specified reader or buffer.
             * @function decode
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {pb.NoiseHandshakePayload} NoiseHandshakePayload
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            NoiseHandshakePayload.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.pb.NoiseHandshakePayload();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                        case 1:
                            message.identityKey = reader.bytes();
                            break;
                        case 2:
                            message.identitySig = reader.bytes();
                            break;
                        case 3:
                            message.data = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                    }
                }
                return message;
            };
            /**
             * Decodes a NoiseHandshakePayload message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {pb.NoiseHandshakePayload} NoiseHandshakePayload
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            NoiseHandshakePayload.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };
            /**
             * Verifies a NoiseHandshakePayload message.
             * @function verify
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            NoiseHandshakePayload.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.identityKey != null && message.hasOwnProperty("identityKey"))
                    if (!(message.identityKey && typeof message.identityKey.length === "number" || $util.isString(message.identityKey)))
                        return "identityKey: buffer expected";
                if (message.identitySig != null && message.hasOwnProperty("identitySig"))
                    if (!(message.identitySig && typeof message.identitySig.length === "number" || $util.isString(message.identitySig)))
                        return "identitySig: buffer expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                        return "data: buffer expected";
                return null;
            };
            /**
             * Creates a NoiseHandshakePayload message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {pb.NoiseHandshakePayload} NoiseHandshakePayload
             */
            NoiseHandshakePayload.fromObject = function fromObject(object) {
                if (object instanceof $root.pb.NoiseHandshakePayload)
                    return object;
                var message = new $root.pb.NoiseHandshakePayload();
                if (object.identityKey != null)
                    if (typeof object.identityKey === "string")
                        $util.base64.decode(object.identityKey, message.identityKey = $util.newBuffer($util.base64.length(object.identityKey)), 0);
                    else if (object.identityKey.length)
                        message.identityKey = object.identityKey;
                if (object.identitySig != null)
                    if (typeof object.identitySig === "string")
                        $util.base64.decode(object.identitySig, message.identitySig = $util.newBuffer($util.base64.length(object.identitySig)), 0);
                    else if (object.identitySig.length)
                        message.identitySig = object.identitySig;
                if (object.data != null)
                    if (typeof object.data === "string")
                        $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length)
                        message.data = object.data;
                return message;
            };
            /**
             * Creates a plain object from a NoiseHandshakePayload message. Also converts values to other types if specified.
             * @function toObject
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {pb.NoiseHandshakePayload} message NoiseHandshakePayload
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            NoiseHandshakePayload.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if (options.bytes === String)
                        object.identityKey = "";
                    else {
                        object.identityKey = [];
                        if (options.bytes !== Array)
                            object.identityKey = $util.newBuffer(object.identityKey);
                    }
                    if (options.bytes === String)
                        object.identitySig = "";
                    else {
                        object.identitySig = [];
                        if (options.bytes !== Array)
                            object.identitySig = $util.newBuffer(object.identitySig);
                    }
                    if (options.bytes === String)
                        object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array)
                            object.data = $util.newBuffer(object.data);
                    }
                }
                if (message.identityKey != null && message.hasOwnProperty("identityKey"))
                    object.identityKey = options.bytes === String ? $util.base64.encode(message.identityKey, 0, message.identityKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.identityKey) : message.identityKey;
                if (message.identitySig != null && message.hasOwnProperty("identitySig"))
                    object.identitySig = options.bytes === String ? $util.base64.encode(message.identitySig, 0, message.identitySig.length) : options.bytes === Array ? Array.prototype.slice.call(message.identitySig) : message.identitySig;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                return object;
            };
            /**
             * Converts this NoiseHandshakePayload to JSON.
             * @function toJSON
             * @memberof pb.NoiseHandshakePayload
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            NoiseHandshakePayload.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };
            return NoiseHandshakePayload;
        })();
        return pb;
    })();
    return $root;
});
//# sourceMappingURL=payload.js.map